import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class ContractorBankAccount {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsString()
  bankName!: string;

  @Expose()
  @IsString()
  accountNumber!: string;

  @Expose()
  @IsString()
  accountCurrency!: string;

  @IsOptional()
  @Expose()
  @IsString()
  description!: string | null;

  @Expose()
  @IsBoolean()
  isLocked!: boolean;

  @Expose()
  @IsBoolean()
  isDefault!: boolean;

  @Expose()
  @IsBoolean()
  isAssigned!: boolean;
}

export class ContractorBankAccountResponse extends GenericTableResponse<ContractorBankAccount> {
  @Expose()
  @IsArray()
  @Type(() => ContractorBankAccount)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BankAccount>;
}
